/**
 * Points the browser tab icon at whatever an administrator uploaded.
 *
 * Every document ships with `<link rel="icon" href="/img/favicon.png">` already in its head, so
 * there is an icon on screen before this runs and none of the three pages ever falls back to
 * requesting /favicon.ico - which in production the SPA fallback answers with index.html, giving the
 * browser HTML where it asked for an image.
 *
 * The existing element's href is set rather than a second link appended: two `rel="icon"` elements
 * leave which one wins to the browser, and the answer differs between them.
 *
 * Does nothing when the setting is empty, which is its default. An unconfigured install keeps the
 * icon the product ships with rather than losing the one it has.
 */
export function applyFavicon(path: string | null | undefined): void {
    if (!path) {
        return;
    }

    const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');

    if (link) {
        link.href = path;
    }
}
